import React, { Component } from 'react';
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  ButtonToolbar,
  Button,
  FormGroup,
  InputGroup,
  FormControl
} from "react-bootstrap";
import _ from "lodash";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit } from "@fortawesome/free-solid-svg-icons";
import { changeAttribute } from "../../actions/auth";
import "./TeamProfile.scss";

class TeamProfile extends Component {
  constructor(props) {
    super(props);

    this.state = {
      companyName: '',
      accountName: '',
      isProfileEditing: false
    };
  }

  componentDidMount() {
    this.setState({
      companyName: _.get(this.props, "user.companyName", ''),
      accountName: _.get(this.props, "user.accountName", ''),
    });
  }

  static getDerivedStateFromProps(props, state) {
    if (!state.isProfileEditing) {
      return {
        companyName: _.get(props, "user.companyName", ''),
        accountName: _.get(props, "user.accountName", ''),
      };
    }

    return null;
  }

  onSaveProfile = () => {
    const { accountName, companyName } = this.state;

    this.props.changeAttribute([
      { name: 'companyName', value: companyName },
      { name: 'accountName', value: accountName }
    ]);
    this.setState({ isProfileEditing: false });
  }

  render() {
    const { isProfileEditing, companyName, accountName } = this.state;
    const isAdmin = _.get(this.props, "cognitoUser.attributes['custom:role']", '') === 'admin';

    return (
      <div className="profile-sidebar">
        <div className="profile-edit">
          <h3>Team Profile</h3>
          {isAdmin && <FontAwesomeIcon icon={faEdit} onClick={() => this.setState({ isProfileEditing: !isProfileEditing && isAdmin  })} />}
        </div>
        <div className="personal-details">
          <div className="personal-info" onDoubleClick={() => this.setState({ isProfileEditing: !isProfileEditing && isAdmin  })}>
            <span className="key">COMPANY NAME</span>
            {!isProfileEditing ?
              <span className="value">{companyName}</span>
              : <FormGroup className="flex-column p-2">
                  <InputGroup>
                    <FormControl
                      className="short-editor"
                      placeholder="Company Name"
                      value={companyName}
                      onChange={(e) => this.setState({ companyName: e.target.value })}
                    />
                  </InputGroup>
                </FormGroup>
            }
          </div>
          <div className="personal-info" onDoubleClick={() => this.setState({ isProfileEditing: !isProfileEditing && isAdmin  })}>
            <span className="key">TEAM NAME</span>
            {!isProfileEditing ?
              <span className="value">{accountName}</span>
              : <FormGroup className="flex-column p-2">
                  <InputGroup>
                    <FormControl
                      className="short-editor"
                      placeholder="Team Name"
                      value={accountName}
                      onChange={(e) => this.setState({ accountName: e.target.value })}
                    />
                  </InputGroup>
                </FormGroup>
            }
          </div>
          <div className="personal-info">
            <span className="key">ACTIVE TEAM MEMBERS</span>
            <span className="value">{this.props.usersCount}</span>
          </div>
          <div className="personal-info">
            <span className="key">CONTENT PIECES</span>
            <span className="value">{this.props.contentsCount}</span>
          </div>
        </div>

        {isAdmin && <ButtonToolbar>
          <Button variant="outline-danger" size="sm" onClick={this.onSaveProfile}>SAVE PROFILE</Button>
        </ButtonToolbar>}
      </div>
    );
  }
};

const mapStateToProps = state => ({
  cognitoUser: state.auth.cognitoUser,
  user: state.auth.tenant,
  usersCount: (state.settings.users.filter(u => !u.disabled && u.isConfirmed) || []).length,
  contentsCount: state.item.items.filter(it => it.collectionId === undefined).length,
});

const mapDispatchToProps = dispatch => 
  bindActionCreators({
    changeAttribute
  }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(TeamProfile);
